import  jQuery from 'jquery';
window.jQuery  = jQuery;
$ = jQuery;

var newmessage,
    oldmessage;

$(function() {

    $( "#webinar-filter" ).on( "selectmenuselect", function( event, ui ) {
        $.ajax({
            type: "GET",
            url: $(self).data('url'),
            dataType: 'html',
            data: $('#WebinarFilterForm').serializeArray(),
            success: function (data) {
                $('.prev-webinars-row').remove();
                $('#PrevWebinarContainer').append(data);

                $('.equal-height').each(function () {
                    var highestBox = 0;
                    $('.equal', this).each(function () {
                        if ($(this).outerHeight() > highestBox) {
                            highestBox = $(this).outerHeight();
                        }
                    });
                    $('.equal', this).height(highestBox);
                });

            }
        });
    });

    $('#WebinarFilterForm').on('submit', function(e) {
        e.preventDefault();
        $.ajax({
            type: "GET",
            url: $(self).data('url'),
            dataType: 'html',
            data: $('#WebinarFilterForm').serializeArray(),
            success: function (data) {
                $('.prev-webinars-row').remove();
                $('#PrevWebinarContainer').append(data);

                $('.equal-height').each(function () {
                    var highestBox = 0;
                    $('.equal', this).each(function () {
                        if ($(this).outerHeight() > highestBox) {
                            highestBox = $(this).outerHeight();
                        }
                    });
                    $('.equal', this).height(highestBox);
                });

            }
        });
    });

    //Reminder notification trigger
    $('.reminder a, .remove-reminder a').on('click', function(e){
        e.preventDefault();

        const $this = $(this),
            webinar = $this.data('webinar'),
            webinarid = $this.data('webinarid'),
            $parent = $this.parent();

        //update position of the fixed navigation
        var headerH = -143,
            headerHpx = "143px";
        if($('.navbar-fixed-top').hasClass('open')){
            $('.navbar-fixed-top').velocity({
                translateY: headerHpx,
                top: headerH
            },{
                duration: 0
            });
        } else {
            $('.navbar-fixed-top').velocity({
                translateY: 0,
                top: headerH
            },{
                duration: 0
            });
        }

        if ($('.WebinarHolder').length) {
            $this.velocity("callout.tada");
        }

        $('.reminder-note h4 strong').text(webinar);

        if ($parent.hasClass('added')) {
            $.ajax({
                url: 'webinars/remove-webinar/' + webinarid,
                success: function() {
                    console.log('finished removing');
                    oldmessage = $('.reminder-note.add');
                    newmessage = $('.reminder-note.remove');
                    if ($('.Webinar').length) {
                        $this.text(hpaTranslatedtext.webinars.reminders.remindMeByEmail); // Remind me by email
                    }

                    showMessage();
                    console.log('finished removing');
                    $('body').scrollTo('.reminder-note.remove', 100, {
                        offset: -50
                    });

                    if ($('.DashboardWebinarsPage').length || $('.DashboardProfilePage').length) {
                        $this.html(hpaTranslatedtext.webinars.reminders.addReminder); // Add reminder
                    }
                    $parent.toggleClass('added');
                }
            });
        } else {
            $.ajax({
                url: 'webinars/add-webinar/' + webinarid,
                success: function() {
                    console.log('finished addming');
                    oldmessage = $('.reminder-note.remove');
                    newmessage = $('.reminder-note.add');
                    if ($('.Webinar').length) {
                        $this.text(hpaTranslatedtext.webinars.reminders.removeReminder); // Remove email reminder
                    }

                    showMessage();
                    $('body').scrollTo('.reminder-note.add', 100, {
                        offset: -50
                    });

                    if ($('.DashboardWebinarsPage').length || $('.DashboardProfilePage').length) {
                        $this.html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="306.4 106.4 347.2 347.2" class="svg-cancel"><path d="M644.3 405.1l-39.2 39.2c-5.6 5.6-13.1 7.5-20.5 7.5-7.5 0-14.9-3.7-20.5-7.5l-84-84-85.9 85.9c-5.6 5.6-13.1 7.5-20.5 7.5s-14.9-3.7-20.5-7.5L314 407c-5.6-5.6-7.5-13.1-7.5-20.5 0-7.5 3.7-14.9 7.5-20.5l85.9-85.9-85.9-85.9c-5.6-5.6-7.5-13.1-7.5-20.5s3.7-14.9 7.5-20.5l39.2-39.2c7.5-3.7 14.9-7.5 20.5-7.5s14.9 3.7 20.5 7.5l85.9 85.9L566 114c5.6-5.6 13.1-7.5 20.5-7.5 7.5 0 14.9 3.7 20.5 7.5l39.2 39.2c5.6 5.6 7.5 13.1 7.5 20.5 0 7.5-3.7 14.9-7.5 20.5L560.3 280l85.9 85.9c5.6 5.6 7.5 13.1 7.5 20.5-.1 7.5-3.8 13.1-9.4 18.7z"></path></svg> ' + hpaTranslatedtext.webinars.reminders.removeReminder); // Remove reminder
                    }
                    $parent.toggleClass('added');
                }
            });

        }

    });

    let pageType = '',
        gefType = '',
        gefBackUrl = '',
        gefMessage = '',
        gefSubmitButtonText = 'Start Watching',
        // gefSubmitButtonText is initialized with English, but will be replaced by translated text if hpaTranslatedtext is available
        gefLockedOverlayHeading = '',
        gefLockedOverlayPara = '';

    const archivedWebinar = $('.ArchivedWebinar');
    if (archivedWebinar.length) {
        pageType = 'ArchivedWebinar';
        gefType = '#webinar-access';
        gefMessage = typeof hpaTranslatedtext !== 'undefined' ? hpaTranslatedtext.webinars.archivedWebinar.availableToWatchBelow : 'Webinar now available to watch below'; // Webinar now available to watch below
        gefLockedOverlayHeading = typeof hpaTranslatedtext !== 'undefined' ? hpaTranslatedtext.webinars.archivedWebinar.watchForFreeHeading : 'Watch this webinar for FREE'; // Watch this webinar for FREE
        gefLockedOverlayPara = typeof hpaTranslatedtext !== 'undefined' ? hpaTranslatedtext.webinars.archivedWebinar.signUpToUnlock : 'Sign up for our email newsletter to instantly unlock access to this webinar.'; // Sign up for our email newsletter to instantly unlock access to this webinar.
    }

    const qAndAVideoPage = $('.QAndAVideoPage');
    if (qAndAVideoPage.length) {
        pageType = 'QAndAVideoPage';
        gefType = '#q-and-a';
        gefMessage = typeof hpaTranslatedtext !== 'undefined' ? hpaTranslatedtext.webinars.qAndAVideo.availableToWatchBelow : 'Q&A video now available to watch below'; // Q&A video now available to watch below
        gefLockedOverlayHeading = typeof hpaTranslatedtext !== 'undefined' ? hpaTranslatedtext.webinars.qAndAVideo.watchForFreeHeading : 'Watch this Q&A video for FREE'; // Watch this Q&A video for FREE
        gefLockedOverlayPara = typeof hpaTranslatedtext !== 'undefined' ? hpaTranslatedtext.webinars.qAndAVideo.signUpToUnlock : 'Sign up for our email newsletter to instantly unlock access to this Q&A video.'; // Sign up for our email newsletter to instantly unlock access to this Q&A video.
    }

    if (pageType) {
        const generalForm = $('#general-email-form'),
            lockedOverlay = $('.locked-overlay');
        if (generalForm.length && lockedOverlay.length) {
            let generalFormHtml = $('#general-email-form').html();
            $('#general-email-form').remove();
            lockedOverlay.find('.locked-form').html(generalFormHtml);
            lockedOverlay.find('.locked-cta h3').html(gefLockedOverlayHeading);
            lockedOverlay.find('.locked-cta p').html(gefLockedOverlayPara);
            $('#GeneralEmailForm_GeneralEmailForm').parsley();
            $('#GeneralEmailForm_GeneralEmailForm_BackURL').val(gefBackUrl);
            $('#GeneralEmailForm_GeneralEmailForm_Type').val(gefType);
            $('#GeneralEmailForm_GeneralEmailForm_Message').val(gefMessage);
            $('#GeneralEmailForm_GeneralEmailForm button[type="submit"]').text(typeof hpaTranslatedtext !== 'undefined' ? hpaTranslatedtext.webinars.general.startWatching : gefSubmitButtonText); // Start Watching
        }
    }

});

function showMessage() {
    newmessage.velocity(
        {
            translateX: "-100%"
        },
        {
            duration: 0,
            begin: function() {
                newmessage.addClass('open');
                oldmessage.removeClass('open');
            }
        }
    ).velocity(
        {
            translateX: "10px"
        },
        {
            duration: 250
        }
    ).velocity(
        {
            translateX: "0"
        },
        {
            duration: 200
        }
    );
}



// WEBPACK FOOTER //
// ./js/modules/webinars.js